export const AUDIENCE_INSIGHTS_TEXTS = {
  processingMessage: "We're unable to provide insights as the audience is still being processed.",
  otherProvidersMessage: "We're unable to provide insights for other providers' data.",
} as const;
